import axios from 'axios'

// body: { email (req), klaviyoListId (opt), sweepstakesId (req) }
export const captureSweepstakesEmail = async (body) =>
  await axios.post('/.netlify/functions/sweepstakes-email-capture', body)

export const handleReferralRequest = async (body) =>
  await axios.post('/.netlify/functions/referral-request', body)
